import * as ng from 'angular';
import * as Dto from './interfaces';
import * as Core from './../core';

interface IProfileResource extends ng.resource.IResourceClass<Dto.IProfile> {
    forgotSecurityQuestionRequest(): Dto.IProfile;
    saveQuestion(params: Object, question: Dto.ISecurityQuestion): Dto.IProfile;
    saveAdminQuestion(params: Object, question: Dto.ISecurityQuestion): Dto.IProfile;
    update(params: any, profile: Dto.IProfile): Dto.IProfile;
    updateAdmin(profile: Dto.IProfile): Dto.IProfile;
    saveAdmin(params: any, profile: Dto.IProfile): Dto.IProfile;
    search(user: Dto.IProfileCriteria): ng.resource.IResourceArray<Dto.IProfile>;
    getAdmin(params: any): Dto.IProfile;
}

let ProfileResourceFactory: Function =
    ($resource: ng.resource.IResourceService, exception: Core.IException, logger: Core.ILogger, SiteConfig: Core.ISiteConfigService): IProfileResource => {

        return <IProfileResource>$resource(
            SiteConfig.getResourceUri("profiles"),
            { id: '@id', accountId: '@_accountId' } as any,
            new ProfileResource(SiteConfig) as any
        );
    };

ProfileResourceFactory.$inject = ["$resource", "exception", "logger", "SiteConfig"];


class ProfileResource {

    constructor(private SiteConfig: Core.ISiteConfigService) {

    }

    public query: ng.resource.IActionDescriptor = {
        method: 'POST',
        isArray: true,
        params: {
            query: true
        }
    };

    public get: ng.resource.IActionDescriptor = {
        method: 'GET',
        isArray: false
    };

    public update: ng.resource.IActionDescriptor = {
        method: 'PUT'
    };

    public updateAdmin: ng.resource.IActionDescriptor = {
        method: 'PUT',
        url: this.SiteConfig.getResourceUri("adminProfiles"),
        params: {
            admin: true,
            id: "@id"
        }
    };

    public saveAdmin: ng.resource.IActionDescriptor = {
        method: 'POST',
        url: this.SiteConfig.getResourceUri("adminProfiles"),
        params: {
            admin: true,
            resetPasswordUri: '@resetPasswordUri'
        }
    };

    public forgotSecurityQuestionRequest: ng.resource.IActionDescriptor = {
        method: 'GET',
        url: this.SiteConfig.getResourceUri("profiles"),
        params: {
            username: '@username'
        }
    };

    public saveQuestion: ng.resource.IActionDescriptor = {
        method: 'PUT',
        params: {
            security: true
        }
    };

    public saveAdminQuestion: ng.resource.IActionDescriptor = {
        url: this.SiteConfig.getResourceUri("adminProfiles"),
        method: 'PUT',
        params: {
            security: true
        }
    };

    public getAdmin: ng.resource.IActionDescriptor = {
        method: 'GET',
        url: this.SiteConfig.getResourceUri("adminProfiles"),
        isArray: false,
        params: {
            security:true
        }
    };

    public search: ng.resource.IActionDescriptor = {
        method: 'POST',
        isArray: true,
        url: this.SiteConfig.getResourceUri("adminProfiles"),
        params: {
            bulk: true
        }
    };

}

let Profile = {
    name: "Profile",
    factory: ProfileResourceFactory
};

export { Profile, IProfileResource }
export default Profile;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/profile.ts